const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
      
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        const currentColor = event.currentTarget.value;
        const dropdown = wrapper.querySelector('.variant-dropdown');
        const selectedVariant = dropdown ? dropdown.value : null;

        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
          if (addButton) {
            addButton.setAttribute('aria-disabled', false);
            addButton.querySelector('span').classList.remove('hidden');
            addButton.querySelector('.sold-out-message').classList.add('hidden');
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
            const variant = product.variants.find(item =>
              item.featured_media != null &&
              item.options.includes(currentColor) &&
              (!selectedVariant || item.options.includes(selectedVariant))
            );

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);

              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  }
                }
                if (!flag) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function () {
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();
                    }
                  }, 200);
                }
              }
            }
          });
        }
      });
    });
  });
};

const checkSelects = () => {
  document.querySelectorAll('.variant-dropdown').forEach(select => {
    select.addEventListener('change', (event) => {
      const wrapper = event.target.closest('.js-color-swatches-wrapper');
      if (!wrapper) return;

      const selectedValue = event.target.value;
      const checkedColorInput = wrapper.querySelector('.js-color-swatches input:checked');
      const currentColor = checkedColorInput ? checkedColorInput.value : null;
      const handleProduct = wrapper.dataset.product;
      console.log("handleProduct",handleProduct);
      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
        const variant = product.variants.find(item =>
          item.options.includes(selectedValue) &&
          (!currentColor || item.options.includes(currentColor))
        );

        if (variant) {
          updateVariant(wrapper, variant.id, `https://cehaeuropebv.myshopify.com/products/${handleProduct}?variant=${variant.id}`, variant.featured_media, product.title);
        }
      });
    });
  });
};

const updateVariant = (wrapper, variantId, variantLink, newImageData = null, productTitle = '') => {
  
  const primaryImage = wrapper.querySelector(".media--first");
  const secondaryImage = wrapper.querySelector(".media--second");
  console.log(variantLink)
  console.log(wrapper)
  wrapper.querySelector('.js-color-swatches-link').setAttribute('href', variantLink);
  const addToCartButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');

  if (addToCartButton) {
    addToCartButton.setAttribute('aria-disabled', false);
    addToCartButton.querySelector('span').classList.remove('hidden');
    addToCartButton.querySelector('.sold-out-message').classList.add('hidden');
    wrapper.querySelector('.card__add-to-cart input[name="id"]').value = variantId;
  }

  if (newImageData && primaryImage) {
    const newPrimaryImage = createImageElement(newImageData, primaryImage.className, primaryImage.sizes, productTitle);

    if (newPrimaryImage.src !== primaryImage.src) {
      let flag = false;
      if (secondaryImage) {
        const secondaryImagePathname = new URL(secondaryImage.src).pathname;
        const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

        if (secondaryImagePathname == newPrimaryImagePathname) {
          primaryImage.remove();
          secondaryImage.classList.remove('media--second');
          secondaryImage.classList.add('media--first');
          flag = true;
        }
      }
      if (!flag) {
        primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
        setTimeout(function () {
          primaryImage.replaceWith(newPrimaryImage);
          newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
          if (secondaryImage) {
            secondaryImage.remove();
          }
        }, 200);
      }
    }
  }
};

function colorSwatches() {
  checkSwatches();
  checkSelects();
  
  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
    checkSelects();
  });
}

(function () {
  colorSwatches();
})();
